module.exports = __webpack_public_path__ + "static/media/selection_icon.0df051d7.png";